var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupportImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1134.41 1483.07",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #231f20;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8 {\n        opacity: .3;\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-111);\n      }\n\n      .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18 {\n        mix-blend-mode: multiply;\n      }\n\n      .cls-9, .cls-10, .cls-13, .cls-14, .cls-16, .cls-17 {\n        opacity: .5;\n      }\n\n      .cls-19 {\n        fill: url(#linear-gradient-61);\n      }\n\n      .cls-20 {\n        fill: url(#linear-gradient-15);\n      }\n\n      .cls-21 {\n        fill: url(#linear-gradient-13);\n      }\n\n      .cls-22 {\n        fill: url(#linear-gradient-107);\n      }\n\n      .cls-23 {\n        fill: url(#linear-gradient-28);\n      }\n\n      .cls-24 {\n        fill: url(#linear-gradient-65);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-53);\n      }\n\n      .cls-25 {\n        fill: url(#linear-gradient-69);\n      }\n\n      .cls-26 {\n        fill: url(#linear-gradient-42);\n      }\n\n      .cls-27 {\n        fill: url(#radial-gradient-48);\n      }\n\n      .cls-27, .cls-28, .cls-29, .cls-30, .cls-31, .cls-32, .cls-33, .cls-34, .cls-35, .cls-36, .cls-37, .cls-38, .cls-39, .cls-40, .cls-41, .cls-42, .cls-43, .cls-44, .cls-45, .cls-46, .cls-47, .cls-48, .cls-49, .cls-50, .cls-51, .cls-52, .cls-53 {\n        mix-blend-mode: color-dodge;\n      }\n\n      .cls-54 {\n        fill: url(#linear-gradient-46);\n      }\n\n      .cls-28 {\n        fill: url(#radial-gradient-24);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-29 {\n        fill: url(#radial-gradient-30);\n      }\n\n      .cls-55 {\n        fill: url(#linear-gradient-70);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-105);\n      }\n\n      .cls-30 {\n        fill: url(#radial-gradient-11);\n      }\n\n      .cls-11 {\n        fill: url(#linear-gradient-102);\n        opacity: .8;\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-56 {\n        fill: url(#linear-gradient-60);\n      }\n\n      .cls-57 {\n        fill: url(#linear-gradient-93);\n      }\n\n      .cls-12 {\n        fill: url(#linear-gradient-114);\n      }\n\n      .cls-58 {\n        fill: url(#linear-gradient-95);\n      }\n\n      .cls-31 {\n        fill: url(#radial-gradient-29);\n      }\n\n      .cls-59 {\n        fill: url(#linear-gradient-87);\n      }\n\n      .cls-32 {\n        fill: url(#radial-gradient-38);\n      }\n\n      .cls-33 {\n        fill: url(#radial-gradient-50);\n      }\n\n      .cls-60 {\n        fill: url(#linear-gradient-64);\n      }\n\n      .cls-34 {\n        fill: url(#radial-gradient-35);\n      }\n\n      .cls-61 {\n        fill: url(#radial-gradient-9);\n      }\n\n      .cls-62 {\n        fill: url(#linear-gradient-43);\n      }\n\n      .cls-63 {\n        fill: url(#linear-gradient-25);\n      }\n\n      .cls-64 {\n        fill: url(#linear-gradient-82);\n      }\n\n      .cls-65 {\n        fill: url(#radial-gradient-28);\n      }\n\n      .cls-66 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-67 {\n        fill: url(#linear-gradient-12);\n      }\n\n      .cls-68 {\n        fill: url(#linear-gradient-40);\n      }\n\n      .cls-69 {\n        fill: url(#linear-gradient-27);\n      }\n\n      .cls-70 {\n        fill: url(#linear-gradient-68);\n      }\n\n      .cls-35 {\n        fill: url(#radial-gradient-22);\n      }\n\n      .cls-71 {\n        fill: url(#linear-gradient-37);\n      }\n\n      .cls-72 {\n        fill: url(#linear-gradient-75);\n      }\n\n      .cls-37 {\n        fill: url(#radial-gradient-60);\n      }\n\n      .cls-73 {\n        fill: url(#radial-gradient-58);\n      }\n\n      .cls-74 {\n        fill: url(#linear-gradient-39);\n      }\n\n      .cls-75 {\n        fill: url(#linear-gradient-55);\n      }\n\n      .cls-75, .cls-76, .cls-77, .cls-78, .cls-79, .cls-80, .cls-81, .cls-82, .cls-83, .cls-84, .cls-85 {\n        opacity: .2;\n      }\n\n      .cls-86 {\n        fill: url(#linear-gradient-89);\n      }\n\n      .cls-76 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-38 {\n        fill: url(#radial-gradient-6);\n      }\n\n      .cls-87 {\n        fill: url(#linear-gradient-113);\n      }\n\n      .cls-88 {\n        fill: url(#radial-gradient-18);\n      }\n\n      .cls-89 {\n        fill: url(#linear-gradient-47);\n      }\n\n      .cls-90 {\n        fill: url(#linear-gradient-26);\n      }\n\n      .cls-91 {\n        fill: url(#linear-gradient-74);\n      }\n\n      .cls-77 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-92 {\n        fill: url(#linear-gradient-97);\n      }\n\n      .cls-93 {\n        fill: url(#linear-gradient-72);\n      }\n\n      .cls-39 {\n        fill: url(#radial-gradient-21);\n      }\n\n      .cls-94 {\n        fill: url(#linear-gradient-35);\n      }\n\n      .cls-95 {\n        fill: url(#radial-gradient-54);\n      }\n\n      .cls-96 {\n        fill: url(#linear-gradient-30);\n      }\n\n      .cls-97 {\n        fill: url(#radial-gradient-37);\n      }\n\n      .cls-98 {\n        fill: url(#linear-gradient-76);\n      }\n\n      .cls-99 {\n        fill: url(#radial-gradient-49);\n      }\n\n      .cls-99, .cls-100, .cls-101, .cls-102 {\n        mix-blend-mode: screen;\n      }\n\n      .cls-103 {\n        fill: url(#radial-gradient);\n      }\n\n      .cls-104 {\n        fill: url(#radial-gradient-3);\n      }\n\n      .cls-40 {\n        fill: url(#radial-gradient-45);\n      }\n\n      .cls-105 {\n        fill: url(#radial-gradient-32);\n      }\n\n      .cls-41 {\n        fill: url(#radial-gradient-34);\n      }\n\n      .cls-106 {\n        fill: url(#linear-gradient-109);\n      }\n\n      .cls-107 {\n        fill: url(#linear-gradient-73);\n      }\n\n      .cls-108 {\n        fill: url(#linear-gradient-71);\n      }\n\n      .cls-109 {\n        fill: url(#linear-gradient-44);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-52);\n      }\n\n      .cls-110 {\n        fill: url(#linear-gradient-96);\n      }\n\n      .cls-111 {\n        fill: url(#linear-gradient-49);\n      }\n\n      .cls-13 {\n        fill: url(#linear-gradient-112);\n      }\n\n      .cls-112 {\n        fill: url(#linear-gradient-34);\n      }\n\n      .cls-113 {\n        fill: url(#radial-gradient-20);\n      }\n\n      .cls-114 {\n        fill: url(#radial-gradient-44);\n      }\n\n      .cls-115 {\n        fill: url(#radial-gradient-41);\n      }\n\n      .cls-116 {\n        fill: url(#linear-gradient-38);\n      }\n\n      .cls-117 {\n        fill: url(#linear-gradient-91);\n      }\n\n      .cls-118 {\n        fill: url(#linear-gradient-22);\n      }\n\n      .cls-119 {\n        fill: url(#linear-gradient-24);\n      }\n\n      .cls-42 {\n        fill: url(#radial-gradient-39);\n      }\n\n      .cls-120 {\n        fill: url(#linear-gradient-94);\n      }\n\n      .cls-43 {\n        fill: url(#radial-gradient-23);\n      }\n\n      .cls-121 {\n        isolation: isolate;\n      }\n\n      .cls-122 {\n        fill: url(#linear-gradient-92);\n      }\n\n      .cls-123 {\n        fill: url(#linear-gradient-90);\n      }\n\n      .cls-124 {\n        fill: url(#radial-gradient-26);\n      }\n\n      .cls-125 {\n        fill: url(#linear-gradient-33);\n      }\n\n      .cls-126 {\n        fill: url(#linear-gradient-79);\n      }\n\n      .cls-14 {\n        fill: url(#linear-gradient-103);\n      }\n\n      .cls-127 {\n        fill: url(#linear-gradient-78);\n      }\n\n      .cls-128 {\n        fill: url(#linear-gradient-66);\n      }\n\n      .cls-78 {\n        fill: url(#linear-gradient-57);\n      }\n\n      .cls-129 {\n        fill: url(#linear-gradient-77);\n      }\n\n      .cls-44 {\n        fill: url(#radial-gradient-16);\n      }\n\n      .cls-130 {\n        fill: url(#linear-gradient-110);\n      }\n\n      .cls-131 {\n        fill: url(#linear-gradient-88);\n      }\n\n      .cls-132 {\n        fill: url(#radial-gradient-8);\n      }\n\n      .cls-133 {\n        fill: url(#radial-gradient-42);\n      }\n\n      .cls-134 {\n        fill: url(#radial-gradient-2);\n      }\n\n      .cls-79 {\n        fill: url(#linear-gradient-56);\n      }\n\n      .cls-135 {\n        fill: url(#linear-gradient-14);\n      }\n\n      .cls-136 {\n        fill: url(#linear-gradient-62);\n      }\n\n      .cls-137 {\n        fill: url(#radial-gradient-27);\n      }\n\n      .cls-80 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-138 {\n        fill: url(#linear-gradient-29);\n      }\n\n      .cls-45 {\n        fill: url(#radial-gradient-15);\n      }\n\n      .cls-46 {\n        fill: url(#radial-gradient-51);\n      }\n\n      .cls-47 {\n        fill: url(#radial-gradient-46);\n      }\n\n      .cls-139 {\n        fill: url(#linear-gradient-20);\n      }\n\n      .cls-140 {\n        fill: url(#radial-gradient-4);\n      }\n\n      .cls-141 {\n        fill: url(#linear-gradient-67);\n      }\n\n      .cls-142 {\n        fill: url(#linear-gradient-17);\n      }\n\n      .cls-143 {\n        fill: url(#linear-gradient-50);\n      }\n\n      .cls-144 {\n        fill: url(#radial-gradient-25);\n      }\n\n      .cls-145 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-146 {\n        fill: url(#radial-gradient-36);\n      }\n\n      .cls-48 {\n        fill: url(#radial-gradient-5);\n      }\n\n      .cls-147 {\n        fill: url(#linear-gradient-59);\n      }\n\n      .cls-148 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-149 {\n        fill: #25054d;\n      }\n\n      .cls-150 {\n        fill: url(#linear-gradient-108);\n      }\n\n      .cls-151 {\n        fill: url(#linear-gradient-19);\n      }\n\n      .cls-152 {\n        fill: url(#linear-gradient-101);\n      }\n\n      .cls-153 {\n        fill: url(#linear-gradient-80);\n      }\n\n      .cls-154 {\n        fill: url(#radial-gradient-12);\n      }\n\n      .cls-155 {\n        fill: url(#radial-gradient-19);\n      }\n\n      .cls-82 {\n        fill: url(#linear-gradient-58);\n      }\n\n      .cls-83 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-156 {\n        fill: url(#linear-gradient-83);\n      }\n\n      .cls-100 {\n        fill: url(#radial-gradient-57);\n      }\n\n      .cls-157 {\n        fill: url(#radial-gradient-52);\n      }\n\n      .cls-158 {\n        fill: url(#radial-gradient-31);\n      }\n\n      .cls-159 {\n        fill: url(#linear-gradient-36);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-51);\n      }\n\n      .cls-160 {\n        fill: url(#linear-gradient-21);\n      }\n\n      .cls-161 {\n        fill: url(#linear-gradient-45);\n      }\n\n      .cls-84 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-162 {\n        fill: url(#linear-gradient-85);\n      }\n\n      .cls-163 {\n        fill: url(#linear-gradient-98);\n      }\n\n      .cls-164 {\n        fill: url(#linear-gradient-81);\n      }\n\n      .cls-165 {\n        fill: url(#linear-gradient-84);\n      }\n\n      .cls-166 {\n        fill: url(#radial-gradient-55);\n      }\n\n      .cls-167 {\n        fill: url(#radial-gradient-33);\n      }\n\n      .cls-49 {\n        fill: url(#radial-gradient-10);\n      }\n\n      .cls-168 {\n        fill: url(#linear-gradient-48);\n      }\n\n      .cls-101 {\n        fill: url(#linear-gradient-100);\n        opacity: .6;\n      }\n\n      .cls-50 {\n        fill: url(#radial-gradient-47);\n      }\n\n      .cls-169 {\n        fill: url(#linear-gradient-32);\n      }\n\n      .cls-170 {\n        fill: url(#linear-gradient-86);\n      }\n\n      .cls-171 {\n        fill: url(#linear-gradient-41);\n      }\n\n      .cls-172 {\n        fill: url(#radial-gradient-7);\n      }\n\n      .cls-51 {\n        fill: url(#radial-gradient-14);\n      }\n\n      .cls-173 {\n        fill: url(#linear-gradient-16);\n      }\n\n      .cls-174 {\n        fill: url(#radial-gradient-17);\n      }\n\n      .cls-175 {\n        fill: url(#radial-gradient-43);\n      }\n\n      .cls-16 {\n        fill: url(#linear-gradient-106);\n      }\n\n      .cls-176 {\n        fill: url(#radial-gradient-13);\n      }\n\n      .cls-177 {\n        fill: url(#linear-gradient-23);\n      }\n\n      .cls-178 {\n        fill: url(#linear-gradient-31);\n      }\n\n      .cls-102 {\n        fill: url(#radial-gradient-56);\n      }\n\n      .cls-179 {\n        fill: #e6e7e8;\n      }\n\n      .cls-180 {\n        fill: url(#linear-gradient-63);\n      }\n\n      .cls-52 {\n        fill: url(#radial-gradient-40);\n      }\n\n      .cls-17 {\n        fill: url(#linear-gradient-104);\n      }\n\n      .cls-53 {\n        fill: url(#radial-gradient-59);\n      }\n\n      .cls-181 {\n        fill: url(#linear-gradient-99);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-85 {\n        fill: url(#linear-gradient-54);\n      }\n\n      .cls-182 {\n        fill: url(#linear-gradient-18);\n      }\n\n      .cls-18 {\n        fill: url(#radial-gradient-53);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 367.25,
    y1: 1189.74,
    x2: 522.68,
    y2: 1189.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1bb0d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#1ebfdd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#23d8ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#1ebfdd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#1bb0d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1bb0d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#1bb0d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#20c6e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#1aafd3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#169bc7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#138fbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#138bbd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 15.74,
    y1: 1275.87,
    x2: 504.99,
    y2: 1166.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#138bbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#169ac6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#1ec2df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2af6ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 381.3,
    y1: 1263.91,
    x2: 401.25,
    y2: 1293.92,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 825.13,
    y1: 1236.4,
    x2: 1199.61,
    y2: 1124.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#ae24b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#d643bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff63ce"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 701.69,
    y1: 1264.89,
    x2: 826.48,
    y2: 1236.92,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 731.12,
    y1: 1244.95,
    x2: 636.6,
    y2: 1244.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#ae24b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#d643bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#ff63ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#dc48c1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 405.23,
    y1: 1352.18,
    x2: 759.13,
    y2: 1352.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#fcce9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#fac099"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#fee0a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#ffe4a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#fcd4a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#f9bd97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#f7ae91"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#f7aa90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9b695"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 372.11,
    y1: 1299.26,
    x2: 466.73,
    y2: 1278.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#ffa98c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#feb892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#fee0a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feeca8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 758.66,
    y1: 513.75,
    x2: 532.98,
    y2: 943.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#6b24d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#7733dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#965bec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a56ef4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 603.09,
    y1: 945.47,
    x2: 983.99,
    y2: 739.42,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 578.65,
    y1: 987.77,
    x2: 737.69,
    y2: 1183.51,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 622.09,
    y1: 980.6,
    x2: 1003.01,
    y2: 774.54,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 636.71,
    y1: 989.98,
    x2: 636.78,
    y2: 990.06,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 638.38,
    y1: 989.37,
    x2: 638.42,
    y2: 989.42,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 149.06,
    y1: 1045.54,
    x2: 821.51,
    y2: 894.8,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 641.64,
    y1: 969.69,
    x2: 723.74,
    y2: 969.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6b24d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#712cd9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#7734dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#8c4ee7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#a56ef4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#6b24d6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 635.86,
    y1: 935.11,
    x2: 635.93,
    y2: 935.2,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 637.63,
    y1: 934.28,
    x2: 637.9,
    y2: 934.61,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 448.73,
    y1: 934.09,
    x2: 449.53,
    y2: 933.91,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 300.96,
    y1: 942.32,
    x2: 513.24,
    y2: 894.73,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 450.47,
    y1: 934.1,
    x2: 450.79,
    y2: 934.03,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 434.95,
    y1: 990.56,
    x2: 456.16,
    y2: 985.81,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 447.92,
    y1: 989.9,
    x2: 451.99,
    y2: 988.99,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 453.21,
    y1: 988.94,
    x2: 453.58,
    y2: 988.86,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 505.74,
    y1: 1007.3,
    x2: 506.24,
    y2: 1007.19,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 458.37,
    y1: 946.19,
    x2: 532.97,
    y2: 946.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7c3adf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#7633dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#6d27d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#6b24d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#9a60ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#7734dc"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 705.05,
    cy: 880.77,
    fx: 705.05,
    fy: 880.77,
    r: 23.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#d8d8d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#a5a5a5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#797979"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#545454"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#353535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#0d0d0d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#030303"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 683.79,
    cy: 970.16,
    fx: 683.79,
    fy: 970.16,
    r: 58.63,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 411.82,
    cy: 920.12,
    fx: 411.82,
    fy: 920.12,
    r: 32.85,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 495.38,
    cy: 914.02,
    fx: 495.38,
    fy: 914.02,
    r: 29.92,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 4909.84,
    cy: 58114.27,
    fx: 4909.84,
    fy: 58114.27,
    r: 38.62,
    gradientTransform: "translate(13685.8 -3368.51) rotate(90.65) scale(.91 .22)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4916a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#3e128a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#2b0d60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#1b083d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#0f0422"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#06020f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#010003"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: 4852.65,
    cy: 58948.33,
    fx: 4852.65,
    fy: 58948.33,
    r: 38.61,
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 575.89,
    y1: 588.48,
    x2: 323.75,
    y2: 1069.02,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 467,
    y1: 998.19,
    x2: 554.31,
    y2: 972.05,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 168.49,
    y1: 1028.72,
    x2: 168.5,
    y2: 1028.74,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    y1: 1076.45,
    y2: 1076.45,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 7.32,
    y1: 1164.48,
    x2: 513.78,
    y2: 1050.95,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 402.34,
    y1: 1084.43,
    x2: 466.25,
    y2: 1180.56,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 425.49,
    y1: 1119.25,
    x2: 451.44,
    y2: 1158.28,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 355.52,
    y1: 1111.85,
    x2: 437.82,
    y2: 1235.64,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 385.33,
    y1: 1156.69,
    x2: 418.75,
    y2: 1206.95,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 402.34,
    y1: 1222.34,
    x2: 466.25,
    y2: 1318.46,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 425.49,
    y1: 1257.16,
    x2: 451.44,
    y2: 1296.19,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: 255.16,
    cy: 1073.76,
    fx: 255.16,
    fy: 1073.76,
    r: 127.44,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-8",
    cx: 474.75,
    cy: 975.37,
    fx: 474.75,
    fy: 975.37,
    r: 17.66,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-9",
    cx: 413.35,
    cy: 1038.89,
    fx: 413.35,
    fy: 1038.89,
    r: 56.68,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-10",
    cx: 5065.61,
    cy: 70215.67,
    fx: 5065.61,
    fy: 70215.67,
    r: 38.61,
    gradientTransform: "translate(13069.97 -3492.56) rotate(90.65) scale(.92 .18)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#972a74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#8a266a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#601a49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3d112f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#22091a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0f040b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#030102"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-11",
    cx: -4937.25,
    cy: 1010.43,
    fx: -4937.25,
    fy: 1010.43,
    r: 41.99,
    gradientTransform: "translate(2380.32 -894.09) rotate(-22.35) scale(.52 1.04) skewX(-.01)",
    xlinkHref: "#radial-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 613.37,
    y1: 1023.43,
    x2: 966.52,
    y2: 1023.43,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 1000.79,
    y1: 622.4,
    x2: 748.66,
    y2: 1102.91,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 795.46,
    y1: 983.78,
    x2: 712.25,
    y2: 983.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9f19ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#ae24b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#d643bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#ff63ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#dc48c1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 858.8,
    y1: 1058.19,
    x2: 923.66,
    y2: 1192.82,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 823.21,
    y1: 1120.4,
    x2: 1210.69,
    y2: 1004.37,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 534.72,
    y1: 1078.74,
    x2: 757.41,
    y2: 1028.82,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 697.38,
    y1: 1149.28,
    x2: 831.79,
    y2: 1119.15,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 690.01,
    y1: 1139.5,
    x2: 754.86,
    y2: 1274.12,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    y1: 1128.38,
    y2: 1128.38,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-12",
    cx: 660.56,
    cy: 1042.79,
    fx: 660.56,
    fy: 1042.79,
    r: 38.21,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-13",
    cx: 759.44,
    cy: 963.67,
    fx: 759.44,
    fy: 963.67,
    r: 27.49,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-14",
    cx: 5743.53,
    cy: 55910.61,
    fx: 5743.53,
    fy: 55910.61,
    r: 38.6,
    gradientTransform: "translate(13874.98 -4653.75) rotate(90.65) scale(1.03 .24)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ad3185"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#8a276a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#601b4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#3d112f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#22091a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#0f040b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#030102"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-15",
    cx: 666.09,
    cy: 1126.99,
    fx: 666.09,
    fy: 1126.99,
    r: 88.84,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-16",
    cx: 907.26,
    cy: 1082.82,
    fx: 907.26,
    fy: 1082.82,
    r: 94.82,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 756.3,
    y1: 801.75,
    x2: 539.53,
    y2: 1214.87,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    y1: 1238.49,
    y2: 1238.49,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 339.86,
    y1: 1168.16,
    x2: 522.5,
    y2: 1127.21,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 626.05,
    y1: 1126.29,
    x2: 521.76,
    y2: 1126.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#f7aa90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#f9b996"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#fee1a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#ffe4a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#f7aa90"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-17",
    cx: 673.56,
    cy: 1126.69,
    fx: 673.56,
    fy: 1126.69,
    r: 0.26,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-18",
    cx: 609.31,
    cy: 1114.22,
    fx: 609.31,
    fy: 1114.22,
    r: 14.38,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-19",
    cx: 428.08,
    cy: 1133.84,
    fx: 428.08,
    fy: 1133.84,
    r: 20.55,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-20",
    cx: 527.15,
    cy: 1217.41,
    fx: 527.15,
    fy: 1217.41,
    r: 132.05,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-21",
    cx: 6678.5,
    cy: 69043.14,
    fx: 6678.5,
    fy: 69043.14,
    r: 31.49,
    gradientTransform: "translate(13111.94 -7187.99) rotate(90.65) scale(1.29 .18)",
    xlinkHref: "#radial-gradient-10"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-22",
    cx: 5121.93,
    cy: 70129.85,
    fx: 5121.93,
    fy: 70129.85,
    r: 31.49,
    gradientTransform: "translate(13069.27 -3425.23) rotate(90.65) scale(.92 .18)",
    xlinkHref: "#radial-gradient-10"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-23",
    cx: -4742.94,
    cy: -3426.84,
    fx: -4742.94,
    fy: -3426.84,
    r: 53.78,
    gradientTransform: "translate(3751.48 2442.4) rotate(-22.35) scale(.52 .66)",
    xlinkHref: "#radial-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 12539.99,
    y1: 1009.87,
    x2: 12695.42,
    y2: 1009.87,
    gradientTransform: "translate(13306.63) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 12188.48,
    y1: 1096.01,
    x2: 12677.71,
    y2: 986.34,
    gradientTransform: "translate(13306.63) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 12554.03,
    y1: 1084.04,
    x2: 12573.98,
    y2: 1114.04,
    gradientTransform: "translate(13306.63) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 12997.86,
    y1: 1056.53,
    x2: 13372.37,
    y2: 944.39,
    gradientTransform: "translate(13306.63) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 12874.43,
    y1: 1085.01,
    x2: 12999.19,
    y2: 1057.05,
    gradientTransform: "translate(13306.63) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 12903.85,
    y1: 1065.08,
    x2: 12809.33,
    y2: 1065.08,
    gradientTransform: "translate(13306.63) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 12577.96,
    y1: 1172.32,
    x2: 12931.87,
    y2: 1172.32,
    gradientTransform: "translate(13306.63) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 12544.85,
    y1: 1119.39,
    x2: 12639.46,
    y2: 1098.18,
    gradientTransform: "translate(13306.63) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-24",
    cx: 1810.72,
    cy: 1273.14,
    fx: 1810.72,
    fy: 1273.14,
    r: 41.06,
    gradientTransform: "translate(277.25 100.15) rotate(89.36) scale(.62 -.18)",
    xlinkHref: "#radial-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 12931.39,
    y1: 333.88,
    x2: 12705.72,
    y2: 763.97,
    gradientTransform: "translate(13306.63) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 12775.82,
    y1: 765.6,
    x2: 13156.75,
    y2: 559.54,
    gradientTransform: "translate(13306.63) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 12751.38,
    y1: 807.9,
    x2: 12910.43,
    y2: 1003.64,
    gradientTransform: "translate(13306.63) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 12794.82,
    y1: 800.73,
    x2: 13175.71,
    y2: 594.69,
    gradientTransform: "translate(13306.63) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 12809.46,
    y1: 810.11,
    x2: 12809.51,
    y2: 810.18,
    gradientTransform: "translate(13306.63) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 12811.12,
    y1: 809.5,
    x2: 12811.16,
    y2: 809.55,
    gradientTransform: "translate(13306.63) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: 12321.79,
    y1: 865.67,
    x2: 12994.25,
    y2: 714.93,
    gradientTransform: "translate(13306.63) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 12814.38,
    y1: 789.82,
    x2: 12896.47,
    y2: 789.82,
    gradientTransform: "translate(13306.63) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-16"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 12808.6,
    y1: 755.24,
    x2: 12808.67,
    y2: 755.33,
    gradientTransform: "translate(13306.63) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 12810.37,
    y1: 754.42,
    x2: 12810.64,
    y2: 754.75,
    gradientTransform: "translate(13306.63) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 12473.7,
    y1: 762.44,
    x2: 12685.97,
    y2: 714.86,
    gradientTransform: "translate(13306.63) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 12623.2,
    y1: 754.24,
    x2: 12623.53,
    y2: 754.16,
    gradientTransform: "translate(13306.63) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: 12607.67,
    y1: 810.71,
    x2: 12628.9,
    y2: 805.95,
    gradientTransform: "translate(13306.63) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: 12620.66,
    y1: 810.03,
    x2: 12624.73,
    y2: 809.12,
    gradientTransform: "translate(13306.63) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: 12625.95,
    y1: 809.07,
    x2: 12626.31,
    y2: 809,
    gradientTransform: "translate(13306.63) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 12678.46,
    y1: 827.44,
    x2: 12678.97,
    y2: 827.32,
    gradientTransform: "translate(13306.63) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: 12631.1,
    y1: 766.31,
    x2: 12705.69,
    y2: 766.31,
    gradientTransform: "translate(13306.63) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-25",
    cx: 12877.78,
    cy: 700.9,
    fx: 12877.78,
    fy: 700.9,
    r: 23.88,
    gradientTransform: "translate(13306.63) rotate(-180) scale(1 -1)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-26",
    cx: 12856.54,
    cy: 790.3,
    fx: 12856.54,
    fy: 790.3,
    r: 58.63,
    gradientTransform: "translate(13306.63) rotate(-180) scale(1 -1)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-27",
    cx: 12584.56,
    cy: 740.25,
    fx: 12584.56,
    fy: 740.25,
    r: 32.85,
    gradientTransform: "translate(13306.63) rotate(-180) scale(1 -1)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-28",
    cx: 12668.12,
    cy: 734.16,
    fx: 12668.12,
    fy: 734.16,
    r: 29.92,
    gradientTransform: "translate(13306.63) rotate(-180) scale(1 -1)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-29",
    cx: 4562.59,
    cy: 3519.59,
    fx: 4562.59,
    fy: 3519.59,
    r: 38.62,
    gradientTransform: "translate(-379.17 -3368.51) rotate(89.35) scale(.91 -.22)",
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-30",
    cx: 4505.4,
    cy: 4353.63,
    fx: 4505.4,
    fy: 4353.63,
    r: 38.62,
    gradientTransform: "translate(-379.17 -3368.51) rotate(89.35) scale(.91 -.22)",
    xlinkHref: "#radial-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: 12748.63,
    y1: 408.62,
    x2: 12496.48,
    y2: 889.15,
    gradientTransform: "translate(13306.63) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: 12639.74,
    y1: 818.32,
    x2: 12727.03,
    y2: 792.18,
    gradientTransform: "translate(13306.63) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: 12539.99,
    y1: 896.58,
    x2: 12695.42,
    y2: 896.58,
    gradientTransform: "translate(13306.63) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: 12180.06,
    y1: 984.61,
    x2: 12686.51,
    y2: 871.08,
    gradientTransform: "translate(13306.63) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: 12573.5,
    y1: 902.16,
    x2: 12654.52,
    y2: 1024.02,
    gradientTransform: "translate(13306.63) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: 12602.84,
    y1: 946.3,
    x2: 12635.74,
    y2: 995.78,
    gradientTransform: "translate(13306.63) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: 12528.25,
    y1: 931.98,
    x2: 12610.56,
    y2: 1055.76,
    gradientTransform: "translate(13306.63) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: 12558.07,
    y1: 976.82,
    x2: 12591.48,
    y2: 1027.08,
    gradientTransform: "translate(13306.63) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: 12573.39,
    y1: 1039.92,
    x2: 12655.57,
    y2: 1163.52,
    gradientTransform: "translate(13306.63) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: 12603.15,
    y1: 1084.69,
    x2: 12636.53,
    y2: 1134.88,
    gradientTransform: "translate(13306.63) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-31",
    cx: 12427.9,
    cy: 893.89,
    fx: 12427.9,
    fy: 893.89,
    r: 127.44,
    gradientTransform: "translate(13306.63) rotate(-180) scale(1 -1)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-32",
    cx: 12647.48,
    cy: 795.5,
    fx: 12647.48,
    fy: 795.5,
    r: 17.66,
    gradientTransform: "translate(13306.63) rotate(-180) scale(1 -1)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-33",
    cx: 12586.08,
    cy: 859.03,
    fx: 12586.08,
    fy: 859.03,
    r: 56.68,
    gradientTransform: "translate(13306.63) rotate(-180) scale(1 -1)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-34",
    cx: 4724.58,
    cy: 2458.72,
    fx: 4724.58,
    fy: 2458.72,
    r: 38.62,
    gradientTransform: "translate(236.66 -3492.56) rotate(89.35) scale(.92 -.18)",
    xlinkHref: "#radial-gradient-10"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-35",
    cx: 16912.52,
    cy: 5312.24,
    fx: 16912.52,
    fy: 5312.24,
    r: 42,
    gradientTransform: "translate(10926.31 -894.09) rotate(-157.65) scale(.52 -1.04) skewX(-.01)",
    xlinkHref: "#radial-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: 12786.09,
    y1: 843.55,
    x2: 13139.26,
    y2: 843.55,
    gradientTransform: "translate(13306.63) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: 13173.54,
    y1: 442.5,
    x2: 12921.39,
    y2: 923.04,
    gradientTransform: "translate(13306.63) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    x1: 12968.2,
    y1: 803.91,
    x2: 12884.99,
    y2: 803.91,
    gradientTransform: "translate(13306.63) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-40"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: 13031.54,
    y1: 878.33,
    x2: 13096.38,
    y2: 1012.93,
    gradientTransform: "translate(13306.63) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    x1: 12995.94,
    y1: 940.53,
    x2: 13383.44,
    y2: 824.5,
    gradientTransform: "translate(13306.63) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    x1: 12707.44,
    y1: 898.87,
    x2: 12930.17,
    y2: 848.94,
    gradientTransform: "translate(13306.63) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: 12870.12,
    y1: 969.41,
    x2: 13004.5,
    y2: 939.28,
    gradientTransform: "translate(13306.63) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-93",
    x1: 12862.75,
    y1: 959.62,
    x2: 12927.6,
    y2: 1094.24,
    gradientTransform: "translate(13306.63) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    x1: 12903.85,
    y1: 948.51,
    x2: 12809.33,
    y2: 948.51,
    gradientTransform: "translate(13306.63) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-36",
    cx: 12833.3,
    cy: 862.93,
    fx: 12833.3,
    fy: 862.93,
    r: 38.22,
    gradientTransform: "translate(13306.63) rotate(-180) scale(1 -1)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-37",
    cx: 12932.17,
    cy: 783.79,
    fx: 12932.17,
    fy: 783.79,
    r: 27.5,
    gradientTransform: "translate(13306.63) rotate(-180) scale(1 -1)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-38",
    cx: 5433.37,
    cy: 4171.23,
    fx: 5433.37,
    fy: 4171.23,
    r: 38.61,
    gradientTransform: "translate(-568.35 -4653.75) rotate(89.35) scale(1.03 -.24)",
    xlinkHref: "#radial-gradient-14"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-39",
    cx: 12838.82,
    cy: 947.13,
    fx: 12838.82,
    fy: 947.13,
    r: 88.84,
    gradientTransform: "translate(13306.63) rotate(-180) scale(1 -1)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-40",
    cx: 13079.99,
    cy: 902.95,
    fx: 13079.99,
    fy: 902.95,
    r: 94.82,
    gradientTransform: "translate(13306.63) rotate(-180) scale(1 -1)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: 12929.04,
    y1: 621.87,
    x2: 12712.27,
    y2: 1035,
    gradientTransform: "translate(13306.63) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: 12577.96,
    y1: 1058.62,
    x2: 12931.87,
    y2: 1058.62,
    gradientTransform: "translate(13306.63) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: 12512.61,
    y1: 988.29,
    x2: 12695.23,
    y2: 947.35,
    gradientTransform: "translate(13306.63) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: 12798.78,
    y1: 946.42,
    x2: 12694.51,
    y2: 946.42,
    gradientTransform: "translate(13306.63) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-50"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-41",
    cx: 12846.3,
    cy: 946.81,
    fx: 12846.3,
    fy: 946.81,
    r: 0.27,
    gradientTransform: "translate(13306.63) rotate(-180) scale(1 -1)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-42",
    cx: 12782.05,
    cy: 934.35,
    fx: 12782.05,
    fy: 934.35,
    r: 14.38,
    gradientTransform: "translate(13306.63) rotate(-180) scale(1 -1)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-43",
    cx: 12600.82,
    cy: 953.97,
    fx: 12600.82,
    fy: 953.97,
    r: 20.54,
    gradientTransform: "translate(13306.63) rotate(-180) scale(1 -1)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-44",
    cx: 12699.88,
    cy: 1037.54,
    fx: 12699.88,
    fy: 1037.54,
    r: 132.06,
    gradientTransform: "translate(13306.63) rotate(-180) scale(1 -1)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-45",
    cx: 6434.01,
    cy: 1286.09,
    fx: 6434.01,
    fy: 1286.09,
    r: 31.49,
    gradientTransform: "translate(194.69 -7187.99) rotate(89.35) scale(1.29 -.18)",
    xlinkHref: "#radial-gradient-10"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-46",
    cx: 4778.67,
    cy: 2372.79,
    fx: 4778.67,
    fy: 2372.79,
    r: 31.49,
    gradientTransform: "translate(237.36 -3425.23) rotate(89.35) scale(.92 -.18)",
    xlinkHref: "#radial-gradient-10"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-47",
    cx: 17106.93,
    cy: 3294.23,
    fx: 17106.93,
    fy: 3294.23,
    r: 53.77,
    gradientTransform: "translate(9555.15 2442.4) rotate(-157.65) scale(.52 -.66)",
    xlinkHref: "#radial-gradient-10"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-48",
    cx: 12785.02,
    cy: 1152.94,
    fx: 12785.02,
    fy: 1152.94,
    r: 132.73,
    gradientTransform: "translate(13306.63) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fa45c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#cb389d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#571843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-49",
    cx: 12786.14,
    cy: 1192.98,
    fx: 12786.14,
    fy: 1192.98,
    r: 36.19,
    gradientTransform: "translate(13306.63) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#c211a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#b8109b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#5b0663"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#500557"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#37033c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#230226"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#130114"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#080008"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#010001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-50",
    cx: 12967.07,
    cy: 1051.72,
    fx: 12967.07,
    fy: 1051.72,
    r: 1.01,
    xlinkHref: "#radial-gradient-48"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-51",
    cx: 13214.09,
    cy: 907.01,
    fx: 13214.09,
    fy: 907.01,
    r: 1.02,
    xlinkHref: "#radial-gradient-48"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: 2231.76,
    y1: -830.72,
    x2: 1981.61,
    y2: -1268.47,
    gradientTransform: "translate(-1247.85 1810.43) rotate(-11.13)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#340558"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#3d065f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#4c086a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#74108a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9f19ab"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-52",
    cx: 588.49,
    cy: 577.14,
    fx: 588.49,
    fy: 577.14,
    r: 303.96,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#feeca8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa98c"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-53",
    cx: 1603.17,
    cy: 1115.04,
    fx: 1603.17,
    fy: 1115.04,
    r: 85.76,
    gradientTransform: "translate(-1072.27 -722.44) rotate(13.53) scale(1.18 .78)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#948f90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-54",
    cx: 552.31,
    cy: 513.1,
    fx: 552.31,
    fy: 513.1,
    r: 607.1,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#f4f2f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#d7cfe7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#a999cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8770b8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-55",
    cx: 550.45,
    cy: 562,
    fx: 550.45,
    fy: 562,
    r: 279.79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbf8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#d4d1d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#a5a5b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9d9eb3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-56",
    cx: 712.55,
    cy: 686.16,
    fx: 712.55,
    fy: 686.16,
    r: 102.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-57",
    cx: 535.6,
    cy: 581.61,
    fx: 535.6,
    fy: 581.61,
    r: 56.35,
    xlinkHref: "#radial-gradient-56"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-58",
    cx: 523.49,
    cy: 364.12,
    fx: 523.49,
    fy: 364.12,
    r: 167.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fedfcb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9b69e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: 437.99,
    y1: 311.08,
    x2: 507.02,
    y2: 376.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: 613.12,
    y1: 491.16,
    x2: 545.13,
    y2: 103.43,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-99"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    x1: 567.68,
    y1: 548.24,
    x2: 503.79,
    y2: 485.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dbac9b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-103",
    x1: 628.99,
    y1: 282.78,
    x2: 669.97,
    y2: 352.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bcbec0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-104",
    x1: 647.99,
    y1: 382.49,
    x2: 676.2,
    y2: 369.19,
    xlinkHref: "#linear-gradient-103"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    x1: 523.26,
    y1: 750.79,
    x2: 471.35,
    y2: 903.12,
    xlinkHref: "#linear-gradient-103"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-106",
    x1: 512.73,
    y1: 166.66,
    x2: 698.79,
    y2: 332.24,
    xlinkHref: "#linear-gradient-103"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-107",
    x1: 16834.71,
    y1: 424.63,
    x2: 16766.39,
    y2: 333.08,
    gradientTransform: "translate(17454.15) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#2d075c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#420f84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#45108a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#25054d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-108",
    x1: 16768.48,
    y1: 393.91,
    x2: 16893.22,
    y2: 356.56,
    gradientTransform: "translate(17454.15) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#25054d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45108a"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-59",
    cx: 16812.14,
    cy: 381.94,
    fx: 16812.14,
    fy: 381.94,
    r: 42.71,
    gradientTransform: "translate(17454.15) rotate(-180) scale(1 -1)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-109",
    x1: 16803.04,
    y1: 419.24,
    x2: 16761.24,
    y2: 363.23,
    gradientTransform: "translate(17454.15) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#a7a9ac"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#b6b8ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#dedfe0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#f1f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#bcbec0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-110",
    x1: 16759.07,
    y1: 402.48,
    x2: 16834.24,
    y2: 379.97,
    gradientTransform: "translate(17454.15) rotate(-180) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#9d9eb3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#d4d1d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eeebf2"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-60",
    cx: 16785.38,
    cy: 395.26,
    fx: 16785.38,
    fy: 395.26,
    r: 25.74,
    gradientTransform: "translate(17454.15) rotate(-180) scale(1 -1)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-111",
    x1: 541.69,
    y1: 382.99,
    x2: 515.02,
    y2: 230.87,
    xlinkHref: "#linear-gradient-103"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-112",
    x1: 470.63,
    y1: 455.58,
    x2: 630.49,
    y2: 455.58,
    xlinkHref: "#linear-gradient-103"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-113",
    x1: 515.23,
    y1: 160.67,
    x2: 702.28,
    y2: 327.12,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-109"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-114",
    x1: 508.48,
    y1: 167.74,
    x2: 686.18,
    y2: 325.88,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-109"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-121"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M456.75,1192.6c-3.29,1.91-9,.75-9.45-1.94-.98-5.67-5.54-11.2-13.69-15.34-14.37-7.31-38.74-7.4-53.1-.21-17.88,8.95-18.54,24.63-1.99,34.19,6.97,4.03,15.82,6.29,24.89,6.78,2.82.16,4.62,1.46,4.86,2.87h.01v.03s0,.09,0,.14v-18.53c9.28.19,18.44,2,25.32,5.5,8.14,4.14,12.71,9.66,13.69,15.34.46,2.69,6.16,3.85,9.45,1.95l62.15-35.89,2.75-.57v-31.79l-64.89,37.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M174,1162.16c-3.6-2.08-5.43-4.8-5.51-7.51v29.61l.08-.03c-.52,3.12,1.3,6.32,5.43,8.71l167.74,96.84v-30.78l-167.74-96.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M406.72,1221.49l-64.98,37.51v30.78l64.98-37.51c1.01-.58,1.46-1.3,1.53-2.03h.03v-.31c0-.06.02-.11,0-.15v-30.65c.07.84-.4,1.68-1.56,2.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M966.5,1183.16l.12-.03v-30.77l-.12.02c.12,2.85-1.67,5.7-5.42,7.88l-166.69,96.24v30.78l166.69-96.25c3.75-2.15,5.55-5.02,5.42-7.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M728.34,1218.37c-2.13-1.23-4.98-1.46-7.39-.97v30.78c2.41-.49,5.26-.25,7.39.98l66.05,38.13v-30.78l-66.05-38.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M716.32,1220.92c-.58,5.22-4.29,10.34-11.17,14.31-15.34,8.85-40.47,8.66-55.57-.57-5.79-3.52-9.18-7.95-10.22-12.49l-.28.08v26.67c-.5,5.93,3.01,11.97,10.5,16.55,15.1,9.21,40.22,9.41,55.57.55,6.88-3.97,10.59-9.09,11.17-14.31.19-1.75,2.17-3.03,4.64-3.52v-30.78c-2.46.5-4.45,1.76-4.64,3.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M627.49,1390.98c-5.73,4.92-17.35,6.24-25.95,2.9l-196.76-76.45v30.77l196.76,76.47c8.6,3.32,20.22,2.03,25.95-2.91l131.2-113.13v-30.78l-131.2,113.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M423.16,1287.52c-10.29-3.99-16.21-10.33-17.12-16.91v27.49c-.54,4.65,1.45,9.33,5.7,13.33l22.22-14.7c3.36-2.89-2.66-6.05-10.79-9.21Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "212.45 1124.09 597.31 1337.56 924.72 1103.56 562.42 898.29 212.45 1124.09"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M460.67,914.9c11.81-11.56,38.3-15.01,57.87-7.19,15.74,6.29,21.8,19.94,13.2,29.75-4.87,5.57-12.97,9.46-22.25,11.38-4.38.91-4.88,4.38-.85,5.77l79.4,27.19,47.12-46.2c3.05-2.98,10.86-2.54,12.76.77,3.07,5.36,9.6,10.08,19.07,12.92,17.75,5.33,39.93,1.89,50.51-7.84,11.61-10.68,5.55-24.78-13.23-31.21-8.43-2.89-17.96-3.73-26.84-2.78-5.93.65-10.41-3.1-7.35-6.1l47.12-46.19-203.96-69.83c-8.92-3.06-20.4-1.38-25.63,3.75l-119.68,117.33,79.5,27.22c3.97,1.36,8.96-.55,8.21-3.17-1.48-5.18.07-10.69,5.03-15.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M677.43,907.46c8.89-.95,18.42-.11,26.84,2.78,3.42,1.17,6.41,2.61,8.97,4.22l3.95-3.88v-55.41l-47.12,46.19c-3.06,3,1.42,6.74,7.35,6.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "M723.12,932.17c-.64,3.19-2.45,6.36-5.62,9.27-10.59,9.73-32.77,13.17-50.51,7.84-9.47-2.85-16-7.56-19.07-12.92-1.89-3.31-9.71-3.75-12.76-.77l-47.12,46.2-79.4-27.19c-4.03-1.39-3.53-4.85.85-5.77,9.28-1.92,17.38-5.81,22.25-11.38,8.59-9.81,2.54-23.46-13.2-29.75-19.57-7.82-46.06-4.36-57.87,7.19-4.96,4.88-6.51,10.39-5.03,15.58.75,2.62-4.24,4.53-8.21,3.17l-79.5-27.22v55.41l79.5,27.22c3.97,1.36,8.96-.55,8.21-3.17-1.48-5.19.07-10.7,5.03-15.57,9.44-9.23,28.24-13.28,45.41-10.55v46.75c-.5,1.27.27,2.72,2.56,3.5l79.4,27.19,47.12-46.2c3.05-2.98,10.86-2.54,12.76.76,3.07,5.36,9.6,10.1,19.07,12.94,17.75,5.33,39.93,1.88,50.51-7.85,4.87-4.48,6.6-9.56,5.62-14.43v-50.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M642.26,989.06v-55.42c-2.66-.21-5.51.4-7.09,1.94l-47.12,46.2v55.41l47.12-46.2c1.58-1.54,4.44-2.15,7.09-1.93Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M636.86,989.91c-.1.03-.22.06-.32.11.1-.05.22-.08.32-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M638.45,989.35s-.1.02-.16.03c.06-.02.11-.02.16-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M508.65,954.6c-4.03-1.39-3.53-4.85.85-5.77,9.28-1.92,17.38-5.81,22.25-11.38,8.59-9.81,2.54-23.46-13.2-29.75-19.57-7.82-46.06-4.36-57.87,7.19-4.96,4.88-6.5,10.39-5.03,15.58.75,2.62-4.24,4.53-8.21,3.17l-79.5-27.22v55.41l79.5,27.22c3.97,1.36,8.96-.55,8.21-3.17-1.47-5.19.07-10.7,5.03-15.57,9.44-9.23,28.24-13.28,45.41-10.55v46.75c-.5,1.27.27,2.72,2.56,3.5l79.4,27.19v-55.41l-79.4-27.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-173",
    d: "M723.12,982.43v-50.25c-.64,3.19-2.45,6.36-5.62,9.27-10.59,9.73-32.77,13.17-50.51,7.84-9.47-2.83-16-7.56-19.07-12.92-1.37-2.41-5.92-3.29-9.47-2.43,1.21-.28,2.53-.38,3.81-.27v55.41c2.47.2,4.76,1.12,5.66,2.69,3.07,5.36,9.6,10.1,19.07,12.94,17.75,5.33,39.93,1.88,50.51-7.85,4.87-4.48,6.6-9.56,5.62-14.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M636.54,934.61c-.51.27-.99.59-1.38.99.39-.39.87-.72,1.38-.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-182",
    d: "M638.29,933.95c-.5.14-.98.33-1.43.53.46-.2.93-.38,1.43-.53Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "M448.99,933.99c.08.03.18.03.27.03-.08,0-.18,0-.27-.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-139",
    points: "441.66 931.66 367.93 906.42 367.93 906.42 441.66 931.66"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-160",
    d: "M450.68,934.06s-.06.01-.1.01c.04,0,.06-.01.1-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M447.43,989.05l-5.77-1.98,5.77,1.98c.51.17,1.03.28,1.56.36-.52-.08-1.04-.19-1.56-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-177",
    d: "M449.25,989.42c.44.05.88.09,1.32.06-.44.02-.88-.01-1.32-.06Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M453.45,988.89h0c-.12.05-.16.06,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M505.99,1006.89c-.05.24-.04.49,0,.72v-.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M505.99,952.37c-.43-1.43.79-2.97,3.51-3.54,9.28-1.92,17.38-5.81,22.25-11.38,8.59-9.81,2.54-23.46-13.2-29.75-19.57-7.82-46.06-4.36-57.87,7.19-4.96,4.88-6.5,10.39-5.03,15.58.36,1.28-.63,2.36-2.19,3.01v55.4c.48-.26,2.64-1.43,2.19-3-1.47-5.19.07-10.7,5.03-15.57,9.42-9.21,28.18-13.26,45.31-10.56v-7.38Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-36"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M669.87,902.81c.07-.07.13-.15.21-.22l47.12-46.2-2.8-.95-44.32,43.46c-1.34,1.3-1.24,2.75-.21,3.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M717.5,938.97c-10.59,9.73-32.77,13.19-50.51,7.84-9.47-2.85-16-7.58-19.07-12.93-1.89-3.3-9.71-3.75-12.76-.77l-47.12,46.2-79.4-27.19c-.74-.26-1.28-.6-1.72-.97-1.78,1.44-1.29,3.63,1.72,4.66l79.4,27.18,47.12-46.19c3.05-2.99,10.86-2.55,12.76.77,3.07,5.34,9.6,10.07,19.07,12.92,17.75,5.34,39.93,1.89,50.51-7.84,4.63-4.26,6.4-9.04,5.73-13.68-.49,3.43-2.33,6.85-5.73,9.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M455.24,929.79c-1.26,1.59-4.82,2.4-7.81,1.38l-76.7-26.26-2.8,2.74,79.5,27.22c3.97,1.37,8.96-.53,8.21-3.16-.17-.65-.32-1.29-.4-1.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M535.51,927c1.15-8.23-5.2-17.06-16.97-21.76-19.57-7.82-46.06-4.37-57.87,7.21-4.38,4.28-6.08,9.06-5.42,13.67.46-3.42,2.21-6.84,5.42-9.97,11.81-11.56,38.3-15.03,57.87-7.21,10.02,4.02,16.1,11.01,16.97,18.07Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M681.15,994.25c-4.74-.06-8.43-15.85-8.21-35.27.23-19.42,4.26-35.13,9.01-35.08,4.75.06,8.43,15.85,8.22,35.27-.22,19.42-4.25,35.13-9.02,35.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M495.83,940.07c-4.75-.05-8.43-15.85-8.21-35.27.22-19.44,4.25-35.13,9-35.09,4.76.06,8.43,15.86,8.21,35.29-.22,19.42-4.25,35.13-9.01,35.07Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M378.52,1083.71c-16.55-9.55-15.9-25.25,1.99-34.2,14.37-7.18,38.73-7.09,53.1.21,8.14,4.15,12.71,9.67,13.69,15.34.46,2.69,6.16,3.85,9.45,1.94l64.89-37.46-66.04-38.12c-4.29-2.46-1.63-6.72,4.39-6.95,9.72-.35,19.23-2.8,26.31-7.36,13.28-8.55,12.88-21.83-.89-30.25-15.09-9.22-40.21-9.42-55.55-.57-6.89,3.99-10.61,9.09-11.18,14.32-.37,3.48-7.72,5.03-12.02,2.56l-66.05-38.13-166.7,96.24c-7.28,4.21-7.24,11.06.08,15.29l167.74,96.84,64.98-37.52c3.24-1.87,1.28-5.14-3.31-5.4-9.07-.49-17.92-2.74-24.89-6.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M486.3,977.11c-7.08,4.57-16.59,7.02-26.31,7.36-6.02.23-8.68,4.49-4.39,6.95l40.18,23.2v-50.08c-.79,4.55-3.91,8.98-9.48,12.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "M168.49,1028.7h-.01v.03s.01-.03.01-.03Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M456.75,1067c-3.29,1.91-9,.75-9.45-1.94-.98-5.67-5.54-11.19-13.69-15.34-14.37-7.31-38.74-7.39-53.1-.21-17.88,8.95-18.54,24.65-1.99,34.2,6.97,4.04,15.82,6.29,24.89,6.78,2.82.15,4.62,1.45,4.86,2.88h.01v.03c.02.05,0,.09,0,.13v6.09c9.28.19,18.44,2.01,25.32,5.51,8.14,4.14,12.71,9.67,13.69,15.34.46,2.68,6.16,3.85,9.45,1.94l62.15-35.87,2.75-.58v-56.41l-64.89,37.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-178",
    d: "M174,1036.57c-3.6-2.08-5.43-4.8-5.51-7.51v54.23l.08-.02c-.52,3.1,1.3,6.32,5.43,8.71l167.74,96.84v-55.41l-167.74-96.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-169",
    d: "M408.29,1093.36h-.01s.01.02.01.03v-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M408.29,1093.36h-.01s.01.02.01.03v-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "M406.72,1095.89l-64.98,37.52v55.41l64.98-37.51c1.01-.58,1.46-1.32,1.53-2.03h.03v-.34s.02-.08,0-.13v-55.28c.07.85-.4,1.68-1.56,2.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M406.72,1095.89l-64.98,37.52v55.41l64.98-37.51c1.01-.58,1.46-1.32,1.53-2.03h.03v-.34s.02-.08,0-.13v-55.28c.07.85-.4,1.68-1.56,2.36Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-81"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-159",
    d: "M408.29,1231.27h-.01s.01.02.01.03v-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M408.29,1231.27h-.01s.01.02.01.03v-.03Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-36"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M406.33,1093.66l-64.59,37.29-167.74-96.85c-2.58-1.5-4.24-3.32-5.01-5.22-1.42,3.52.23,7.39,5.01,10.14l167.74,96.86,64.98-37.53c2.42-1.4,1.94-3.58-.39-4.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M486.3,974.64c-7.08,4.57-16.59,7.02-26.31,7.36-5.66.21-8.35,4-5.05,6.5,1.12-.86,2.85-1.48,5.05-1.56,9.72-.34,19.23-2.81,26.31-7.38,7.51-4.84,10.63-11.2,9.44-17.33-.82,4.48-3.94,8.85-9.44,12.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M456.75,1064.54c-3.29,1.91-9,.74-9.45-1.94-.98-5.67-5.54-11.2-13.69-15.34-14.37-7.3-38.74-7.4-53.1-.21-10.45,5.23-14.98,12.76-13.65,20.03,1.02-5.62,5.56-11.06,13.65-15.11,14.37-7.19,38.73-7.09,53.1.22,8.14,4.13,12.71,9.65,13.69,15.33.46,2.69,6.16,3.85,9.45,1.95l64.89-37.46-4.27-2.47-60.62,35Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M405.64,1087.39c-3.82-.05-6.74-16.07-6.52-35.79.22-19.72,3.51-35.67,7.34-35.62,3.83.03,6.76,16.05,6.54,35.78-.23,19.72-3.52,35.68-7.35,35.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M431.35,1040.08c9.14,22.23,7.54,43.98-3.58,48.55-11.12,4.58-27.54-9.77-36.69-32.01-9.14-22.23-7.54-43.98,3.58-48.55,11.14-4.58,27.55,9.76,36.69,32.01Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "M756.48,968.94c16.54,9.55,15.91,25.24-1.98,34.19-14.38,7.19-38.74,7.09-53.11-.21-8.15-4.13-12.71-9.66-13.68-15.34-.46-2.67-6.17-3.85-9.45-1.94l-64.89,37.46,66.03,38.14c4.27,2.47,1.63,6.73-4.38,6.94-9.72.35-19.23,2.79-26.33,7.36-13.26,8.57-12.87,21.84.88,30.25,15.1,9.22,40.22,9.42,55.57.57,6.88-3.97,10.59-9.1,11.17-14.31.38-3.48,7.74-5.04,12.02-2.55l66.05,38.12,166.69-96.25c7.28-4.19,7.25-11.04-.09-15.27l-167.74-96.84-64.98,37.51c-3.25,1.86-1.28,5.13,3.31,5.39,9.08.51,17.93,2.76,24.9,6.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M756.48,968.94c16.54,9.55,15.91,25.24-1.98,34.19-14.38,7.19-38.74,7.09-53.11-.21-8.15-4.13-12.71-9.66-13.68-15.34-.46-2.67-6.17-3.85-9.45-1.94l-64.89,37.46,66.03,38.14c4.27,2.47,1.63,6.73-4.38,6.94-9.72.35-19.23,2.79-26.33,7.36-13.26,8.57-12.87,21.84.88,30.25,15.1,9.22,40.22,9.42,55.57.57,6.88-3.97,10.59-9.1,11.17-14.31.38-3.48,7.74-5.04,12.02-2.55l66.05,38.12,166.69-96.25c7.28-4.19,7.25-11.04-.09-15.27l-167.74-96.84-64.98,37.51c-3.25,1.86-1.28,5.13,3.31,5.39,9.08.51,17.93,2.76,24.9,6.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M754.5,1003.13c17.89-8.95,18.52-24.64,1.98-34.19-6.96-4.03-15.82-6.28-24.9-6.79-2.93-.16-4.78-1.56-4.88-3.03h-.1v49.3c10.13.22,20.38-1.53,27.9-5.29Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-171",
    d: "M966.5,1078.9l.12-.02v-55.41l-.12.04c.12,2.85-1.67,5.7-5.42,7.86l-166.69,96.25v55.41l166.69-96.24c3.75-2.16,5.55-5.04,5.42-7.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M966.5,1078.9l.12-.02v-55.41l-.12.04c.12,2.85-1.67,5.7-5.42,7.86l-166.69,96.25v55.41l166.69-96.24c3.75-2.16,5.55-5.04,5.42-7.89Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M648.69,1075.53c7.1-4.57,16.61-7.02,26.33-7.36,6.01-.21,8.65-4.47,4.38-6.94l-66.03-38.14v55.41l25.71,14.86.28-.09c-1.41-6.25,1.66-12.78,9.33-17.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M728.34,1089.49c-2.13-1.23-4.98-1.46-7.39-.98v55.41c2.41-.48,5.26-.25,7.39.96l66.05,38.14v-55.41l-66.05-38.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-161",
    d: "M716.32,1092.04c-.58,5.21-4.29,10.33-11.17,14.31-15.34,8.85-40.47,8.65-55.57-.57-5.79-3.54-9.18-7.95-10.22-12.51l-.28.09v51.3c-.5,5.91,3.01,11.96,10.5,16.54,15.1,9.21,40.22,9.41,55.57.55,6.88-3.97,10.59-9.1,11.17-14.31.19-1.76,2.17-3.03,4.64-3.53v-55.41c-2.46.5-4.45,1.76-4.64,3.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M716.32,1092.04c-.58,5.21-4.29,10.33-11.17,14.31-15.34,8.85-40.47,8.65-55.57-.57-5.79-3.54-9.18-7.95-10.22-12.51l-.28.09v51.3c-.5,5.91,3.01,11.96,10.5,16.54,15.1,9.21,40.22,9.41,55.57.55,6.88-3.97,10.59-9.1,11.17-14.31.19-1.76,2.17-3.03,4.64-3.53v-55.41c-2.46.5-4.45,1.76-4.64,3.53Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-36"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M680.07,1064.13c1.95-1.52,2.04-3.8-.67-5.37l-61.77-35.67-4.26,2.46,66.03,38.13c.26.14.47.28.67.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-176",
    d: "M731.58,964.61c9.08.49,17.93,2.76,24.9,6.79,6.88,3.97,10.74,9.01,11.68,14.17,1.25-6.8-2.62-13.87-11.68-19.1-6.96-4.02-15.82-6.29-24.9-6.79-1.15-.06-2.14-.32-2.91-.69l-.39.22c-3.25,1.87-1.28,5.15,3.31,5.4Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M657.15,1152.63c-5.01-.05-8.88-17.91-8.63-39.88.25-21.96,4.52-39.73,9.53-39.67,5.01.05,8.88,17.91,8.63,39.88-.24,21.97-4.52,39.73-9.53,39.67Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M728.34,1087.02c-4.29-2.47-11.65-.93-12.02,2.55-.58,5.22-4.29,10.33-11.17,14.3-15.34,8.85-40.47,8.66-55.57-.57-5.96-3.64-9.41-8.21-10.32-12.91-1.16,6.34,2.28,12.92,10.32,17.84,15.1,9.23,40.22,9.42,55.57.57,6.88-3.99,10.59-9.08,11.17-14.31.38-3.48,7.74-5.03,12.02-2.57l65.57,37.87v-4.93l-65.57-37.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M961.08,1033.82c4.72-2.71,6.34-6.55,4.93-10.06-.77,1.88-2.39,3.68-4.93,5.15l-166.69,96.24-.47-.28v4.93l.47.27,166.69-96.25Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M666.91,1140.3c-12.95,11.15-39.74,13.72-58.51,5.26-15.09-6.81-19.78-20.62-10.24-30.12,5.42-5.4,13.9-9.01,23.36-10.62,4.48-.77,5.31-4.22,1.42-5.72l-76.59-29.77-51.66,44.53c-3.34,2.88-11.11,2.18-12.67-1.19-2.52-5.45-8.59-10.37-17.75-13.53-17.19-5.91-39.68-3.22-51.22,6.15-12.67,10.28-8,24.55,10.1,31.58,8.13,3.15,17.55,4.31,26.53,3.65,6-.44,10.1,3.44,6.74,6.33l-51.65,44.54,196.76,76.45c8.6,3.36,20.22,2.06,25.95-2.9l131.2-113.12-76.69-29.8c-3.84-1.48-9.01.24-8.52,2.89.95,5.22-1.13,10.67-6.57,15.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M627.49,1264.96c-5.73,4.95-17.35,6.25-25.95,2.9l-196.76-76.45v55.41l196.76,76.46c8.6,3.36,20.22,2.05,25.95-2.88l131.2-113.14v-55.4l-131.2,113.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M449.69,1140.54c-8.98.66-18.4-.5-26.53-3.65-10.29-4-16.21-10.32-17.12-16.93v52.14c-.54,4.64,1.45,9.31,5.7,13.32l44.7-38.55c3.35-2.89-.75-6.76-6.74-6.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M621.53,1104.82c-9.46,1.61-17.94,5.22-23.36,10.62-9.55,9.5-4.85,23.31,10.24,30.12,5.15,2.32,10.91,3.79,16.83,4.49v-47.53c-.43,1.02-1.67,1.93-3.7,2.29Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-36"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-174",
    d: "M673.63,1126.33c-.1.22-.13.47-.13.71.05-.24.1-.48.13-.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M598.16,1112.97c-4.08,4.07-5.54,8.93-4.71,13.69.52-3.1,2.03-6.09,4.71-8.77,5.42-5.38,13.9-9,23.36-10.62,4.27-.73,5.18-3.9,1.83-5.5-.53.24-1.11.46-1.83.57-9.46,1.62-17.94,5.24-23.36,10.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-155",
    d: "M423.16,1139.35c8.13,3.15,17.55,4.31,26.53,3.65,2.75-.2,5.09.52,6.51,1.62l.24-.21c3.35-2.9-.75-6.77-6.74-6.34-8.98.66-18.4-.49-26.53-3.66-9.95-3.85-15.81-9.9-17-16.28-1.59,8.06,4.5,16.35,17,21.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M627.49,1262.51c-5.73,4.93-17.35,6.24-25.95,2.89l-192.82-74.91-3.93,3.39,196.76,76.45c8.6,3.34,20.22,2.04,25.95-2.91l131.2-113.12-3.94-1.52-127.26,109.73Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M613.83,1329.14c-3.12-.04-5.46-18.25-5.2-40.68.25-22.43,3-40.58,6.11-40.55,3.12.05,5.44,18.24,5.2,40.68-.27,22.43-3,40.59-6.11,40.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M420.35,1169.47c-3.12-.02-5.51-13.02-5.32-28.99.18-15.97,2.86-28.9,5.99-28.88,3.12.04,5.51,13.02,5.32,29-.18,15.99-2.87,28.91-5.99,28.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M638.44,1262.56c7.5,18.23,2.03,37.76-12.21,43.62-14.24,5.85-31.86-4.18-39.36-22.42-7.5-18.25-2.02-37.76,12.22-43.61,14.23-5.85,31.85,4.17,39.35,22.42Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M677.15,1012.75c3.29,1.89,9,.73,9.46-1.96.97-5.67,5.54-11.19,13.69-15.34,14.38-7.3,38.73-7.39,53.11-.22,17.88,8.96,18.53,24.65,1.98,34.21-6.97,4.02-15.83,6.27-24.91,6.78-2.81.15-4.62,1.45-4.87,2.86h-.01v.04s0,.09,0,.15v-18.53c-9.26.17-18.42,1.99-25.31,5.5-8.15,4.13-12.72,9.66-13.69,15.34-.46,2.68-6.16,3.85-9.46,1.94l-62.15-35.87-2.74-.58v-31.78l64.89,37.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M959.9,982.29c3.61-2.08,5.43-4.81,5.51-7.51v29.62l-.08-.04c.51,3.11-1.3,6.33-5.43,8.71l-167.74,96.86v-30.79l167.74-96.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M727.17,1041.63l64.98,37.51v30.79l-64.98-37.53c-1.01-.58-1.47-1.29-1.55-2.02h-.03v-.33s-.01-.1,0-.13v-30.64c-.05.83.41,1.67,1.58,2.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M167.4,1003.29l-.12-.02v-30.78l.12.04c-.12,2.84,1.68,5.69,5.42,7.86l166.71,96.24v30.78l-166.71-96.25c-3.76-2.15-5.54-5.02-5.42-7.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M405.55,1038.49c2.12-1.23,4.98-1.46,7.39-.96v30.78c-2.41-.49-5.27-.25-7.39.98l-66.03,38.12v-30.78l66.03-38.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M417.58,1041.06c.56,5.21,4.29,10.34,11.17,14.29,15.34,8.87,40.47,8.67,55.56-.57,5.8-3.53,9.18-7.93,10.22-12.49l.28.09v26.67c.49,5.92-3.01,11.94-10.51,16.54-15.09,9.21-40.22,9.41-55.56.57-6.88-3.98-10.61-9.11-11.17-14.31-.19-1.77-2.19-3.04-4.65-3.54v-30.78c2.46.5,4.45,1.76,4.65,3.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M506.4,1211.11c5.73,4.94,17.36,6.24,25.95,2.9l196.76-76.45v30.77l-196.76,76.47c-8.6,3.34-20.22,2.04-25.95-2.91l-131.2-113.13v-30.78l131.2,113.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M710.75,1107.65c10.27-3.99,16.21-10.32,17.11-16.92v27.52c.54,4.64-1.45,9.31-5.7,13.32l-22.2-14.7c-3.36-2.9,2.66-6.05,10.79-9.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M518.87,1249.04c4.08-.05,7.25-11.51,7.09-25.62-.16-14.09-3.58-25.49-7.66-25.44-4.08.04-7.25,11.51-7.09,25.62.16,14.1,3.59,25.49,7.66,25.44Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "921.45 944.21 536.59 1157.68 209.18 923.69 571.47 718.42 921.45 944.21"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-147",
    d: "M673.23,735.04c-11.81-11.58-38.3-15.03-57.88-7.21-15.72,6.29-21.78,19.95-13.19,29.75,4.86,5.57,12.96,9.46,22.24,11.39,4.38.9,4.88,4.39.85,5.76l-79.4,27.19-47.12-46.2c-3.05-2.99-10.86-2.54-12.76.78-3.06,5.35-9.61,10.06-19.07,12.93-17.74,5.34-39.92,1.88-50.51-7.85-11.61-10.68-5.56-24.76,13.22-31.19,8.42-2.89,17.96-3.74,26.85-2.78,5.94.64,10.41-3.1,7.36-6.09l-47.12-46.2,203.98-69.83c8.9-3.05,20.37-1.37,25.61,3.76l119.68,117.32-79.5,27.22c-3.97,1.37-8.96-.54-8.22-3.15,1.47-5.2-.06-10.7-5.03-15.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M456.46,727.59c-8.89-.96-18.43-.11-26.85,2.78-3.42,1.17-6.41,2.6-8.96,4.21l-3.95-3.87v-55.41l47.12,46.2c3.06,2.99-1.42,6.73-7.36,6.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M410.78,752.29c.63,3.2,2.44,6.37,5.61,9.27,10.59,9.73,32.77,13.2,50.51,7.85,9.47-2.87,16.01-7.58,19.07-12.93,1.9-3.31,9.72-3.77,12.76-.78l47.12,46.2,79.4-27.19c4.03-1.37,3.53-4.85-.85-5.76-9.28-1.93-17.38-5.82-22.24-11.39-8.59-9.8-2.53-23.46,13.19-29.75,19.58-7.82,46.06-4.37,57.88,7.21,4.96,4.88,6.5,10.37,5.03,15.58-.74,2.61,4.25,4.52,8.22,3.15l79.5-27.22v55.41l-79.5,27.22c-3.97,1.37-8.96-.53-8.22-3.17,1.47-5.19-.06-10.68-5.03-15.56-9.44-9.25-28.25-13.28-45.42-10.56v46.74c.5,1.28-.27,2.73-2.56,3.49l-79.4,27.2-47.12-46.18c-3.05-3-10.86-2.55-12.76.77-3.06,5.35-9.61,10.06-19.07,12.92-17.74,5.35-39.92,1.9-50.51-7.85-4.87-4.47-6.6-9.56-5.61-14.42v-50.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-136",
    d: "M491.64,809.19v-55.41c2.66-.23,5.51.38,7.1,1.93l47.12,46.2v55.4l-47.12-46.18c-1.59-1.56-4.44-2.17-7.1-1.95Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M497.03,810.04c.09.03.22.07.31.12-.08-.05-.21-.09-.31-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M495.45,809.47s.1.01.16.03c-.05-.02-.11-.02-.16-.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M625.25,774.73c4.03-1.37,3.53-4.85-.85-5.76-9.28-1.93-17.38-5.82-22.24-11.39-8.59-9.8-2.53-23.44,13.19-29.75,19.58-7.82,46.06-4.37,57.88,7.21,4.96,4.88,6.48,10.37,5.03,15.58-.74,2.61,4.25,4.52,8.22,3.15l79.5-27.22v55.41l-79.5,27.22c-3.97,1.37-8.96-.53-8.22-3.17,1.46-5.19-.06-10.68-5.03-15.56-9.44-9.25-28.25-13.28-45.42-10.56v46.74c.5,1.28-.27,2.73-2.56,3.49l-79.4,27.2v-55.4l79.4-27.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M410.78,802.57v-50.27c.63,3.2,2.44,6.37,5.61,9.27,10.59,9.73,32.77,13.2,50.51,7.85,9.47-2.85,16.01-7.58,19.07-12.93,1.39-2.42,5.92-3.29,9.47-2.42-1.2-.3-2.53-.4-3.81-.29v55.41c-2.46.21-4.75,1.11-5.67,2.71-3.06,5.35-9.61,10.07-19.07,12.92-17.74,5.35-39.92,1.9-50.51-7.85-4.87-4.47-6.6-9.56-5.61-14.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "M497.34,754.73c.53.27,1,.61,1.4.99-.4-.38-.87-.72-1.4-.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M495.6,754.09c.51.14.98.32,1.43.53-.45-.21-.92-.41-1.43-.53Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-25",
    points: "692.24 751.79 765.97 726.55 765.97 726.55 692.24 751.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M683.22,754.19s.06.01.1.02c-.04-.01-.07-.01-.1-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "M686.47,809.18l5.77-1.97-5.77,1.97c-.52.17-1.03.3-1.56.37.54-.08,1.04-.2,1.56-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M684.64,809.55c-.45.05-.88.07-1.32.07.44.02.87-.02,1.32-.07Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "M680.46,809.03v-.03c.11.06.15.09,0,.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M627.92,827.02c.04.24.03.49,0,.73v-.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M627.92,772.5c.4-1.42-.8-2.97-3.52-3.53-9.28-1.93-17.38-5.82-22.24-11.39-8.59-9.8-2.53-23.44,13.19-29.75,19.58-7.82,46.06-4.37,57.88,7.21,4.96,4.88,6.48,10.37,5.03,15.58-.36,1.26.63,2.36,2.21,3.01v55.38c-.48-.25-2.65-1.43-2.21-2.99,1.46-5.19-.06-10.68-5.03-15.56-9.43-9.24-28.18-13.28-45.31-10.57v-7.38Z"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-36"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-144",
    d: "M464.02,722.95c-.07-.08-.12-.16-.2-.23l-47.12-46.2,2.81-.96,44.32,43.46c1.34,1.3,1.24,2.75.2,3.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M416.39,759.1c10.59,9.73,32.77,13.19,50.51,7.85,9.47-2.86,16.01-7.57,19.07-12.92,1.9-3.32,9.71-3.76,12.76-.77l47.12,46.19,79.4-27.18c.74-.25,1.28-.59,1.72-.97,1.78,1.43,1.3,3.64-1.72,4.66l-79.4,27.19-47.12-46.19c-3.05-2.99-10.86-2.54-12.76.77-3.06,5.34-9.61,10.08-19.07,12.92-17.74,5.33-39.92,1.89-50.51-7.84-4.62-4.26-6.4-9.04-5.74-13.68.5,3.42,2.35,6.84,5.74,9.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "M678.66,749.92c1.26,1.58,4.82,2.41,7.81,1.38l76.7-26.25,2.8,2.74-79.5,27.22c-3.97,1.35-8.96-.54-8.22-3.17.18-.64.32-1.27.41-1.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M598.37,747.16c-1.14-8.26,5.21-17.09,16.98-21.79,19.58-7.83,46.06-4.36,57.88,7.2,4.37,4.28,6.07,9.06,5.42,13.67-.46-3.41-2.22-6.83-5.42-9.99-11.81-11.56-38.3-15.03-57.88-7.19-10.02,4-16.09,11-16.98,18.09Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M452.74,814.38c4.76-.05,8.43-15.85,8.21-35.27-.23-19.43-4.26-35.13-9.01-35.07-4.75.05-8.43,15.84-8.21,35.27.22,19.42,4.24,35.12,9.01,35.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M638.05,760.21c4.76-.06,8.43-15.85,8.22-35.29-.23-19.42-4.25-35.13-9.01-35.08-4.75.06-8.43,15.86-8.21,35.27.23,19.43,4.25,35.13,9,35.09Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M755.38,903.83c16.54-9.54,15.9-25.22-1.98-34.19-14.38-7.19-38.73-7.09-53.11.21-8.15,4.13-12.72,9.67-13.69,15.35-.46,2.67-6.16,3.84-9.46,1.93l-64.89-37.45,66.04-38.12c4.28-2.48,1.62-6.74-4.39-6.95-9.71-.36-19.23-2.8-26.31-7.36-13.28-8.57-12.88-21.85.88-30.25,15.1-9.21,40.22-9.42,55.56-.57,6.9,3.99,10.62,9.1,11.18,14.32.37,3.48,7.72,5.03,12.01,2.54l66.05-38.11,166.7,96.25c7.29,4.19,7.25,11.04-.08,15.27l-167.74,96.85-64.98-37.51c-3.24-1.88-1.28-5.15,3.3-5.4,9.08-.5,17.93-2.76,24.91-6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "M647.6,797.25c7.08,4.56,16.6,7.01,26.31,7.36,6.01.21,8.67,4.47,4.39,6.95l-40.18,23.19v-50.08c.76,4.56,3.91,8.97,9.48,12.58Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M677.15,887.13c3.29,1.91,9,.74,9.46-1.93.97-5.68,5.54-11.22,13.69-15.35,14.38-7.3,38.73-7.4,53.11-.21,17.88,8.96,18.53,24.64,1.98,34.19-6.97,4.04-15.83,6.29-24.91,6.8-2.81.16-4.62,1.45-4.87,2.87v-.02s-.01.05-.01.05c-.01.03,0,.09,0,.15v6.08c-9.26.2-18.42,2.02-25.31,5.51-8.15,4.14-12.72,9.66-13.69,15.34-.46,2.68-6.16,3.84-9.46,1.95l-62.15-35.89-2.74-.57v-56.41l64.89,37.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "M959.9,856.69c3.61-2.08,5.43-4.8,5.51-7.51v54.25l-.08-.03c.51,3.1-1.3,6.32-5.43,8.71l-167.74,96.85v-55.41l167.74-96.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-153",
    d: "M725.6,913.47v.02s0,.02,0,.03v-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-164",
    d: "M725.6,913.47v.02s0,.02,0,.03v-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M727.17,916.02l64.98,37.51v55.41l-64.98-37.51c-1.01-.58-1.47-1.31-1.55-2.03h-.03v-.32c0-.05-.01-.1,0-.14v-55.28c-.05.84.41,1.67,1.58,2.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "M727.17,916.02l64.98,37.51v55.41l-64.98-37.51c-1.01-.58-1.47-1.31-1.55-2.03h-.03v-.32c0-.05-.01-.1,0-.14v-55.28c-.05.84.41,1.67,1.58,2.35Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-81"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-165",
    d: "M725.6,1051.4h.01s-.01.03-.01.05v-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M725.6,1051.4h.01s-.01.03-.01.05v-.05Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-36"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-158",
    d: "M727.56,913.78l64.6,37.29,167.74-96.84c2.58-1.5,4.24-3.31,5.01-5.21,1.42,3.51-.24,7.38-5.01,10.14l-167.74,96.85-64.98-37.51c-2.43-1.4-1.93-3.59.38-4.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M647.6,794.77c7.08,4.58,16.59,7.04,26.31,7.38,5.66.2,8.33,3.98,5.05,6.49-1.12-.87-2.85-1.49-5.05-1.56-9.72-.35-19.23-2.81-26.31-7.38-7.51-4.84-10.64-11.21-9.44-17.33.82,4.51,3.94,8.87,9.44,12.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M677.15,884.68c3.29,1.89,9,.73,9.46-1.94.97-5.69,5.54-11.22,13.69-15.35,14.38-7.31,38.73-7.41,53.11-.2,10.45,5.22,14.97,12.75,13.65,20.02-1.04-5.62-5.55-11.06-13.65-15.09-14.38-7.2-38.73-7.11-53.11.2-8.15,4.13-12.72,9.66-13.69,15.35-.46,2.68-6.16,3.84-9.46,1.93l-64.89-37.46,4.27-2.45,60.62,35Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M728.26,907.52c3.82-.04,6.75-16.06,6.53-35.78-.24-19.72-3.52-35.68-7.35-35.62-3.83.04-6.76,16.07-6.53,35.79.23,19.71,3.51,35.67,7.35,35.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M702.54,860.2c-9.14,22.26-7.53,44.01,3.59,48.57,11.12,4.57,27.54-9.77,36.69-32.01,9.14-22.24,7.53-44-3.6-48.56-11.11-4.57-27.54,9.75-36.69,32Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M377.42,789.06c-16.54,9.56-15.91,25.25,1.98,34.19,14.38,7.19,38.73,7.1,53.12-.2,8.14-4.15,12.71-9.67,13.67-15.34.47-2.7,6.16-3.85,9.45-1.96l64.9,37.46-66.05,38.13c-4.27,2.47-1.62,6.73,4.4,6.96,9.71.34,19.22,2.79,26.31,7.35,13.26,8.57,12.87,21.85-.89,30.26-15.09,9.21-40.22,9.4-55.56.55-6.88-3.97-10.61-9.08-11.17-14.31-.38-3.48-7.73-5.02-12.04-2.55l-66.03,38.13-166.71-96.24c-7.28-4.22-7.25-11.06.09-15.29l167.74-96.85,64.97,37.52c3.26,1.87,1.28,5.15-3.29,5.4-9.09.51-17.93,2.76-24.9,6.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M377.42,789.06c-16.54,9.56-15.91,25.25,1.98,34.19,14.38,7.19,38.73,7.1,53.12-.2,8.14-4.15,12.71-9.67,13.67-15.34.47-2.7,6.16-3.85,9.45-1.96l64.9,37.46-66.05,38.13c-4.27,2.47-1.62,6.73,4.4,6.96,9.71.34,19.22,2.79,26.31,7.35,13.26,8.57,12.87,21.85-.89,30.26-15.09,9.21-40.22,9.4-55.56.55-6.88-3.97-10.61-9.08-11.17-14.31-.38-3.48-7.73-5.02-12.04-2.55l-66.03,38.13-166.71-96.24c-7.28-4.22-7.25-11.06.09-15.29l167.74-96.85,64.97,37.52c3.26,1.87,1.28,5.15-3.29,5.4-9.09.51-17.93,2.76-24.9,6.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-131",
    d: "M379.4,823.26c-17.89-8.94-18.53-24.64-1.98-34.19,6.97-4.03,15.82-6.28,24.9-6.79,2.93-.16,4.77-1.54,4.88-3.03l.1.02v49.29c-10.12.2-20.38-1.53-27.89-5.31Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M167.4,899.03l-.12-.02v-55.41l.12.05c-.12,2.83,1.68,5.7,5.42,7.86l166.71,96.24v55.41l-166.71-96.25c-3.76-2.15-5.54-5.02-5.42-7.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "M167.4,899.03l-.12-.02v-55.41l.12.05c-.12,2.83,1.68,5.7,5.42,7.86l166.71,96.24v55.41l-166.71-96.25c-3.76-2.15-5.54-5.02-5.42-7.87Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-117",
    d: "M485.2,895.66c-7.09-4.55-16.6-7.01-26.31-7.35-6.02-.23-8.67-4.49-4.4-6.96l66.05-38.13v55.41l-25.71,14.86-.28-.08c1.41-6.27-1.67-12.79-9.34-17.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M405.55,909.61c2.12-1.21,4.98-1.46,7.39-.98v55.41c-2.41-.48-5.27-.23-7.39.98l-66.03,38.12v-55.41l66.03-38.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M417.58,912.16c.56,5.23,4.29,10.33,11.17,14.31,15.34,8.85,40.47,8.65,55.56-.55,5.8-3.54,9.18-7.95,10.22-12.5l.28.08v51.3c.49,5.92-3.01,11.94-10.51,16.54-15.09,9.22-40.22,9.4-55.56.55-6.88-3.97-10.61-9.09-11.17-14.3-.19-1.75-2.19-3.03-4.65-3.54v-55.41c2.46.51,4.45,1.77,4.65,3.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-120",
    d: "M417.58,912.16c.56,5.23,4.29,10.33,11.17,14.31,15.34,8.85,40.47,8.65,55.56-.55,5.8-3.54,9.18-7.95,10.22-12.5l.28.08v51.3c.49,5.92-3.01,11.94-10.51,16.54-15.09,9.22-40.22,9.4-55.56.55-6.88-3.97-10.61-9.09-11.17-14.3-.19-1.75-2.19-3.03-4.65-3.54v-55.41c2.46.51,4.45,1.77,4.65,3.53Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-36"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "M453.82,884.27c-1.95-1.52-2.03-3.82.67-5.37l61.78-35.68,4.27,2.47-66.05,38.13c-.24.14-.46.3-.67.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M402.32,784.74c-9.09.5-17.93,2.76-24.9,6.78-6.88,3.98-10.74,9.01-11.67,14.18-1.26-6.8,2.62-13.86,11.67-19.1,6.97-4.01,15.82-6.28,24.9-6.79,1.15-.06,2.13-.32,2.91-.69l.38.22c3.26,1.87,1.28,5.15-3.29,5.4Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M476.74,972.76c5.02-.05,8.88-17.91,8.64-39.89-.25-21.96-4.52-39.72-9.54-39.66-5,.05-8.87,17.9-8.62,39.87.24,21.97,4.51,39.74,9.53,39.68Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M405.55,907.15c4.3-2.47,11.66-.93,12.04,2.56.56,5.21,4.29,10.32,11.17,14.3,15.34,8.86,40.47,8.66,55.56-.57,5.98-3.64,9.42-8.21,10.33-12.9,1.16,6.34-2.28,12.92-10.33,17.83-15.09,9.22-40.22,9.43-55.56.57-6.88-3.98-10.61-9.09-11.17-14.31-.38-3.48-7.73-5.03-12.04-2.55l-65.57,37.86v-4.92l65.57-37.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M172.81,853.95c-4.71-2.71-6.35-6.54-4.93-10.06.77,1.89,2.39,3.67,4.93,5.15l166.71,96.23.46-.25v4.92l-.46.26-166.71-96.25Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M467,960.43c12.94,11.15,39.73,13.72,58.51,5.26,15.09-6.79,19.77-20.62,10.22-30.12-5.41-5.4-13.89-9.01-23.35-10.63-4.48-.75-5.32-4.21-1.43-5.71l76.59-29.76,51.66,44.53c3.34,2.88,11.11,2.18,12.67-1.19,2.53-5.44,8.59-10.37,17.77-13.53,17.19-5.92,39.68-3.2,51.22,6.15,12.67,10.28,8.01,24.55-10.1,31.58-8.13,3.16-17.57,4.31-26.56,3.65-5.98-.43-10.08,3.45-6.73,6.35l51.66,44.52-196.76,76.47c-8.6,3.34-20.22,2.04-25.95-2.9l-131.2-113.13,76.7-29.8c3.83-1.49,8.99.24,8.51,2.88-.94,5.24,1.13,10.68,6.59,15.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-110",
    d: "M506.4,1085.1c5.73,4.94,17.36,6.24,25.95,2.9l196.76-76.47v55.42l-196.76,76.46c-8.6,3.34-20.22,2.04-25.95-2.9l-131.2-113.12v-55.42l131.2,113.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M684.19,960.66c8.99.66,18.42-.49,26.56-3.65,10.27-4,16.21-10.33,17.11-16.92v52.13c.54,4.65-1.45,9.32-5.7,13.32l-44.69-38.53c-3.35-2.9.75-6.78,6.73-6.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "M512.38,924.94c9.45,1.62,17.93,5.24,23.35,10.63,9.55,9.5,4.87,23.33-10.22,30.12-5.16,2.32-10.92,3.79-16.83,4.49v-47.53c.43,1.03,1.66,1.94,3.7,2.28Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-36"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M460.27,946.44c.09.23.12.48.12.74-.04-.25-.09-.5-.12-.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M535.71,933.09c4.09,4.09,5.56,8.94,4.73,13.7-.52-3.09-2.04-6.09-4.73-8.77-5.4-5.37-13.88-9-23.33-10.61-4.29-.73-5.2-3.91-1.84-5.51.53.25,1.12.46,1.84.57,9.45,1.62,17.93,5.24,23.33,10.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-175",
    d: "M710.75,959.48c-8.13,3.16-17.57,4.31-26.56,3.65-2.74-.2-5.07.52-6.49,1.62l-.24-.21c-3.35-2.88.75-6.77,6.73-6.34,8.99.66,18.42-.49,26.56-3.65,9.94-3.86,15.79-9.92,16.99-16.27,1.59,8.05-4.5,16.34-16.99,21.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M506.4,1082.62c5.73,4.95,17.36,6.25,25.95,2.91l192.82-74.92,3.94,3.4-196.76,76.45c-8.6,3.34-20.22,2.03-25.95-2.91l-131.2-113.12,3.94-1.52,127.26,109.71Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M520.07,1149.28c3.13-.04,5.45-18.26,5.19-40.69-.25-22.43-2.99-40.58-6.11-40.54-3.13.02-5.45,18.24-5.2,40.66.27,22.44,3,40.6,6.12,40.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M713.54,989.6c3.13-.02,5.51-13.01,5.32-28.99-.18-15.99-2.85-28.9-5.99-28.88-3.12.04-5.5,13.03-5.33,29.01.18,15.97,2.87,28.89,5.99,28.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M495.46,1082.69c-7.5,18.23-2.03,37.76,12.21,43.61,14.24,5.86,31.86-4.18,39.36-22.42,7.49-18.23,2.02-37.75-12.22-43.61-14.24-5.86-31.86,4.17-39.35,22.42Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M521.4,1194.07c1.98,0,3.97-.36,5.89-1.1l202.28-78.89-.9-2.29-202.29,78.88c-4.7,1.84-10.01.95-13.86-2.32l-136.51-115.93-1.59,1.88,136.51,115.93c2.98,2.52,6.69,3.85,10.47,3.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M484.3,1192.99c0,19.98,16.2,36.18,36.18,36.18s36.19-16.2,36.19-36.18-16.21-36.2-36.19-36.2-36.18,16.2-36.18,36.2Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-33",
    x1: 338.89,
    y1: 1053.06,
    x2: 340.13,
    y2: 1050.94
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-46",
    x1: 93.11,
    y1: 906.22,
    x2: 91.86,
    y2: 908.35
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M696.36,301.06c23.6-14.37,66.81,20.69,46.56,76.83-20.25,56.14-61.55,111.62-20.95,162.92,32.98,41.68,67.22,54.2,67.22,54.2,0,0-229.28,37.87-209.13-125.02,15.3-123.63,116.29-168.93,116.29-168.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "M749.23,605.17c-31.36-26.42-90.94-59.47-159.76-94.14-52.53-26.47-110.57-30.84-156.46,0-24.09,16.19-37.61,46.1-37.61,75.98,0,20.31-3.25,39-15.8,59.42-13.16,21.44-22.42,36.8-29.34,49.65-21.06,39.11-10.53,78.98,28.59,103.8,33.82,21.46,168.31,93.23,209.11,103.81,19.71,5.1,40.07,6.66,55.87,6.92,55.33,4.47,150.61-20.38,150.61-52.68,0-23.54,5.99-209.63-45.21-252.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M704.01,614.53c-11.28,46.88-78.06,71-149.17,53.87-71.1-17.11-119.59-68.97-108.31-115.84,11.28-46.87,78.07-70.99,149.15-53.88,71.1,17.12,119.59,68.98,108.32,115.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-179",
    d: "M528.59,856.9c-9.74-5.66-19.82-11.51-30.03-17.45,10.21,5.93,20.29,11.8,30.03,17.45Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M528.59,856.9c-9.74-5.66-19.82-11.51-30.03-17.45,10.21,5.93,20.29,11.8,30.03,17.45Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M514.25,495.1c-19.03,6.34-34.45,36.77-32.34,74.21,2.54,45.03,16.49,60.26,16.49,60.26l41.23-60.26,24.51,76.71s35.3-12.94,61.75-34.21c28.28-22.73,45.67-46.94,32.97-67.14-15.24-24.25-120.23-57.69-144.6-49.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M737.83,600.71c-29.49,6.66-66.28,37.11-72.31,93.56-5.58,52.35-2.85,177.92-2.85,177.92,0,0-19.77-165.16.94-216.93,22.2-55.5,61.85-61.85,61.85-61.85l12.37,7.3Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-100",
    points: "564.13 646.02 539.62 569.31 498.4 629.57 494.75 619.89 539.47 564.71 569.44 643.68 564.13 646.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M435.46,288.35c-9.67,41.72-7.78,166.47,23.61,193.11,24.84,21.08,47.13,7.18,48.66,37.81,1.53,30.64-11.36,33.51,7.4,46.95,17.97,12.89,121.51,3.56,118.99-29.27-2.35-30.81-9.23-41.81,5.07-70.4,14.29-28.58,55.66-74.55,49.52-115.39-6.13-40.85-219.05-210.38-253.26-62.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M440.04,291.49s-8.88,86.9,3.8,121.78c12.7,34.89,86.91-46.3,95.15-79.28,8.24-32.99-22.84-62.79-98.95-42.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M433.68,291.36s-36.81-20.49,35.49-87.35c63.46-58.68,175.27-61.05,232.01,20.47,55.72,80.06,23.54,165.81-16.3,206.55-28.25,28.88-49.32,44.71-49.32,44.71,0,0,13.16-39.64,24.57-54.12,16.64-21.14,28.71-49.1,15.87-65.28-7.17-9.01-18.39-13.89-34,1.71-25.88,25.88-60.93-70.8-137.35-62.6-55.71,5.97-54.46,2.25-70.97-4.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M525.58,504.06c-7.58.25-15.14-.09-26.62-3.53,5.05,3.09,8.25,8.29,8.77,18.74,1.53,30.64-11.36,33.51,7.4,46.95,6.46,4.64,24.21,7.28,44.17,7.26,29.06-29.36,26.78-77.84,26.78-77.84,0,0-37.59,7.7-60.51,8.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M701.18,224.48c-1.78-2.56-3.76-4.77-5.64-7.16-17.43,6.87-35.32,18.97-44.13,40.46-10.76,26.2-38.21,53.41-61.68,73.28,22.9,20.8,38.84,40.44,52.28,26.99,15.61-15.61,26.83-10.73,34-1.7,12.84,16.17.77,44.13-15.87,65.27-11.41,14.49-24.57,54.12-24.57,54.12,0,0,21.08-15.83,49.32-44.71,39.83-40.74,72.02-126.49,16.3-206.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M654.59,397.73s22.36-23.3,14.27-35.21c-8.08-11.89-21.88,6.19-21.88,6.19l7.61,29.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M650.4,786.34s-40.62,93.27-182.04,42.87c-88.19-31.43-114.46-84.11-122.34-124.06-14.95,36.11-3.26,71.82,32.83,94.72,33.82,21.46,168.31,93.23,209.11,103.81,19.71,5.1,40.07,6.66,55.87,6.92,5.57.46,11.55.59,17.79.47-17.53-51.76-11.22-124.74-11.22-124.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M675.09,367.08s3.33-15.7,3.33-41.87c0-49.28-34.09-124.13-109.68-130.8-75.59-6.67-102.96,15.08-102.96,15.08,0,0,25.89-46.57,119.63-35.09,86.57,10.61,114.3,104.27,113.02,144.14-1.11,34.45-4.43,54.38-4.43,54.38l-18.92-5.84Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M614.76,403.5c0,12.24,4.22,20.91,11.09,25.11.2.12,11.72,7.27,11.93,7.39,7.15,4,2.58-5.06,13.43-11.33,21.83-12.6,39.53-43.13,39.53-68.18,0-12.38,11.46-12.48,4.44-16.62-.19-.11-13.1-7.48-13.29-7.58-7.12-3.86-16.86-3.15-27.59,3.05-21.83,12.6-39.54,43.12-39.54,68.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M627.7,411.21c0,25.06,17.7,35.15,39.53,22.54,21.82-12.6,39.53-43.13,39.53-68.18s-17.7-35.14-39.53-22.54c-21.83,12.6-39.53,43.13-39.53,68.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M665.32,342.08c10.47-6.04,19.98-6.85,27.05-3.31-6.6-1.84-14.77-.47-23.63,4.65-21.84,12.6-39.54,43.12-39.54,68.17,0,13.05,4.81,22.02,12.49,25.87-9.66-2.7-15.9-12.31-15.9-27.19,0-25.05,17.7-55.59,39.53-68.19Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M644.85,403.93c0,7.38,2.54,12.6,6.68,15.13.12.08,14.58,8.71,14.7,8.79,4.3,2.4,1.55-3.07,8.09-6.84,13.15-7.59,23.82-25.98,23.82-41.08,0-7.47,6.9-7.52,2.68-10.02-.13-.07-15.41-8.83-15.52-8.9-4.3-2.33-10.17-1.89-16.64,1.84-13.15,7.59-23.82,25.99-23.82,41.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M660.15,412.91c0,15.1,10.67,21.18,23.82,13.58,13.16-7.6,23.83-26,23.83-41.1s-10.67-21.17-23.83-13.58c-13.15,7.59-23.82,25.99-23.82,41.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M682.83,371.24c6.31-3.64,12.04-4.13,16.3-2-3.98-1.11-8.9-.28-14.24,2.81-13.15,7.58-23.82,25.98-23.82,41.08,0,7.86,2.89,13.27,7.52,15.59-5.82-1.63-9.58-7.42-9.58-16.38,0-15.09,10.66-33.5,23.82-41.1Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M504.65,295.45c71.02-7.61,106.3,75.27,131.71,66.27-13.81-12.44-30.89-29.2-43.68-46.26-25.39-33.85-59.24-34.97-110.57-34.97-31.9,0-47.88-2.84-57.73-9.58-.69,14.85,9.31,20.46,9.31,20.46,16.51,6.33,15.25,10.07,70.96,4.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M506.24,491.58c-19.6,0-34.53-3.49-35.61-3.74l2.11-8.78c.42.1,43.33,10.08,77.93-4.5,32.4-13.63,72.98-54.58,73.38-54.98l6.44,6.33c-1.71,1.75-42.29,42.65-76.31,56.98-16.01,6.74-33.28,8.69-47.94,8.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M504.75,487.45c-19.6,0-34.53-3.49-35.61-3.76l2.11-8.77c.42.13,43.33,10.08,77.93-4.48,32.4-13.65,72.98-54.59,73.38-54.99l6.44,6.33c-1.71,1.72-42.29,42.64-76.31,56.98-16.01,6.73-33.28,8.69-47.94,8.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M478.45,489.92c-.65,0-1.31-.07-1.97-.22l-19.45-4.12c-5.09-1.08-8.35-6.08-7.27-11.18,1.09-5.07,6.14-8.31,11.18-7.27l19.45,4.13c5.1,1.09,8.35,6.09,7.28,11.19-.94,4.43-4.87,7.48-9.22,7.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M678.46,362.16s3.35-15.78,3.35-42.1c0-49.54-34.27-124.78-110.26-131.5-76-6.7-103.52,15.16-103.52,15.16,0,0,26.03-46.83,120.27-35.28,87.04,10.67,114.91,104.83,113.61,144.92-1.11,34.64-4.45,54.66-4.45,54.66l-19.01-5.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M682.74,363.47c1.4-6.45,5.04-25.16,5.04-46.39,0-49.54-37.26-125.91-113.25-132.61-58.78-5.18-90.05,6.75-101.24,12.45-3.68,4.02-5.25,6.79-5.25,6.79,0,0,27.52-21.85,103.52-15.14,75.99,6.71,110.26,81.95,110.26,131.49,0,26.32-3.36,42.1-3.36,42.1l4.28,1.31Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportImage);
export default __webpack_public_path__ + "static/media/support-image.96f7037129179bf1585fe251cf817ea8.svg";
export { ForwardRef as ReactComponent };